import { create } from "zustand";
import { CopyBuffer } from "../utils/copyBuffer";
import { PlaybackCaretIndicatorDialogTestbed } from "../testbeds/PlaybackCarretIndicatorDialogTestbed";

export type CopyBufferStore = {
    buffer?: CopyBuffer;
    setBuffer: (buffer?: CopyBuffer) => void;

}
export const copyBufferStore = create<CopyBufferStore>((set) => ({
    buffer: undefined,
    setBuffer: (buffer?: CopyBuffer) => set({ buffer })
}));

export const useCopyBufferStore = () => {
    return copyBufferStore((state) => ({
        buffer: state.buffer,
        setBuffer: state.setBuffer,
    }));
}
export const useCopyBuffer = () => {
    return copyBufferStore((state) => state.buffer);
}
export const useSetCopyBuffer = () => {
    return copyBufferStore((state) => state.setBuffer);
}